import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_CONFIG from '../config/api';
import Sidebar from '../Sidebar';

const FinanceiroAdmin = ({ onLogout }) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
    const [loading, setLoading] = useState(true);
    const [resumo, setResumo] = useState({
        em_dia: 0,
        atrasados: 0,
        vencendo_hoje: 0,
        total_receber: 0,
        total_recebido: 0
    });
    const [faturas, setFaturas] = useState([]);
    const [filtro, setFiltro] = useState('todos');
    
    // Modais
    const [modalPagamento, setModalPagamento] = useState({ aberto: false, fatura: null, valor: '', forma: 'Pix', acao: 'manter' });
    const [modalHistorico, setModalHistorico] = useState({ aberto: false, fatura: null });

    // Estado para controle de Data
    const dataAtual = new Date();
    const [mesSelecionado, setMesSelecionado] = useState(dataAtual.getMonth() + 1);
    const [anoSelecionado, setAnoSelecionado] = useState(dataAtual.getFullYear());

    const mudarMes = (direcao) => {
        let novoMes = mesSelecionado + direcao;
        let novoAno = anoSelecionado;

        if (novoMes > 12) {
            novoMes = 1;
            novoAno++;
        } else if (novoMes < 1) {
            novoMes = 12;
            novoAno--;
        }

        // Validação de Limites
        const dataAlvo = new Date(novoAno, novoMes - 1);
        // Limite Inferior: Dezembro 2025
        const dataMinima = new Date(2025, 11); 
        
        // Limite Superior: 3 meses à frente
        const dataMaxima = new Date();
        dataMaxima.setMonth(dataMaxima.getMonth() + 3);
        // Ajustar para o último dia do mês para garantir comparação correta
        dataMaxima.setDate(1); 

        if (dataAlvo < dataMinima) {
            alert('Histórico limitado a Dezembro de 2025.');
            return;
        }

        if (dataAlvo > dataMaxima) {
            alert('Não é permitido avançar mais que 3 meses.');
            return;
        }

        setMesSelecionado(novoMes);
        setAnoSelecionado(novoAno);
    };

    const carregarFinanceiro = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_CONFIG.API_URL}/financeiro/dashboard`, {
                headers: { 'x-auth-token': token },
                params: {
                    mes: mesSelecionado,
                    ano: anoSelecionado
                }
            });

            if (response.data.success) {
                setResumo(response.data.resumo);
                setFaturas(response.data.faturas);
            }
        } catch (error) {
            console.error('Erro ao carregar financeiro:', error);
        } finally {
            setLoading(false);
        }
    };

    const abrirModalPagamento = (fatura) => {
        const saldoDevedor = fatura.valor - (fatura.valor_pago || 0);
        setModalPagamento({
            aberto: true,
            fatura: fatura,
            valor: saldoDevedor.toFixed(2),
            forma: 'Pix',
            acao: fatura.loja_status === 'bloqueada_financeiro' ? 'desbloquear' : 'manter'
        });
    };

    const enviarPagamento = async () => {
        if (!modalPagamento.valor || parseFloat(modalPagamento.valor) <= 0) {
            alert('Valor inválido');
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${API_CONFIG.API_URL}/financeiro/pagamento/${modalPagamento.fatura.fatura_id}`, {
                valor: modalPagamento.valor,
                forma_pagamento: modalPagamento.forma,
                acao_loja: modalPagamento.acao === 'manter' ? null : modalPagamento.acao
            }, {
                headers: { 'x-auth-token': token }
            });
            
            setModalPagamento({ ...modalPagamento, aberto: false });
            carregarFinanceiro(); 
        } catch (error) {
            console.error(error);
            alert('Erro ao registrar pagamento');
        } finally {
            setLoading(false);
        }
    };

    const bloquearLoja = async (lojaId, acao) => {
        if (!window.confirm(`Tem certeza que deseja ${acao} esta loja?`)) return;

        try {
            const token = localStorage.getItem('token');
            await axios.post(`${API_CONFIG.API_URL}/financeiro/bloquear-loja/${lojaId}`, 
                { acao }, 
                { headers: { 'x-auth-token': token } }
            );
            carregarFinanceiro();
        } catch (error) {
            alert(`Erro ao ${acao} loja`);
        }
    };

    // Recarregar quando mudar mês/ano
    useEffect(() => {
        carregarFinanceiro();
    }, [mesSelecionado, anoSelecionado]);

    const listaFiltrada = faturas.filter(f => {
        if (filtro === 'todos') return true;
        return f.status === filtro;
    });

    if (loading) return <div style={{ padding: '20px' }}>Carregando financeiro...</div>;

    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
            <Sidebar user={user} onLogout={onLogout} />
            <main style={{ flex: 1, padding: '30px', overflowY: 'auto' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                        <h1 style={{ fontSize: '24px', color: '#1a202c', margin: 0 }}>Financeiro Geral</h1>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', background: 'white', padding: '10px 20px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                            <button 
                                onClick={() => mudarMes(-1)} 
                                style={{ cursor: 'pointer', border: 'none', background: 'transparent', fontSize: '20px', color: '#4a5568', fontWeight: 'bold' }}
                                title="Mês Anterior"
                            >
                                &#9664;
                            </button>
                            <span style={{ fontSize: '16px', fontWeight: 'bold', minWidth: '180px', textAlign: 'center', color: '#2d3748' }}>
                                {new Date(anoSelecionado, mesSelecionado - 1).toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' }).toUpperCase()}
                            </span>
                            <button 
                                onClick={() => mudarMes(1)} 
                                style={{ cursor: 'pointer', border: 'none', background: 'transparent', fontSize: '20px', color: '#4a5568', fontWeight: 'bold' }}
                                title="Próximo Mês"
                            >
                                &#9654;
                            </button>
                        </div>
                    </div>

                    {/* Cards de Resumo */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' }}>
                <div style={{ background: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <p style={{ color: '#718096', marginBottom: '5px' }}>Total a Receber</p>
                    <h2 style={{ fontSize: '24px', color: '#2d3748' }}>R$ {resumo.total_receber.toFixed(2)}</h2>
                </div>
                <div style={{ background: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <p style={{ color: '#718096', marginBottom: '5px' }}>Total Recebido</p>
                    <h2 style={{ fontSize: '24px', color: '#38a169' }}>R$ {resumo.total_recebido.toFixed(2)}</h2>
                </div>
                <div style={{ background: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <p style={{ color: '#718096', marginBottom: '5px' }}>Lojas Inadimplentes</p>
                    <h2 style={{ fontSize: '24px', color: '#e53e3e' }}>{resumo.atrasados}</h2>
                </div>
                <div style={{ background: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <p style={{ color: '#718096', marginBottom: '5px' }}>Em Dia</p>
                    <h2 style={{ fontSize: '24px', color: '#3182ce' }}>{resumo.em_dia}</h2>
                </div>
            </div>

            {/* Filtros */}
            <div style={{ marginBottom: '20px' }}>
                <button onClick={() => setFiltro('todos')} style={{ marginRight: '10px', padding: '8px 16px', borderRadius: '20px', border: 'none', background: filtro === 'todos' ? '#3182ce' : '#e2e8f0', color: filtro === 'todos' ? 'white' : '#4a5568', cursor: 'pointer' }}>Todos</button>
                <button onClick={() => setFiltro('pendente')} style={{ marginRight: '10px', padding: '8px 16px', borderRadius: '20px', border: 'none', background: filtro === 'pendente' ? '#3182ce' : '#e2e8f0', color: filtro === 'pendente' ? 'white' : '#4a5568', cursor: 'pointer' }}>Aberto</button>
                <button onClick={() => setFiltro('atrasado')} style={{ marginRight: '10px', padding: '8px 16px', borderRadius: '20px', border: 'none', background: filtro === 'atrasado' ? '#e53e3e' : '#e2e8f0', color: filtro === 'atrasado' ? 'white' : '#4a5568', cursor: 'pointer' }}>Atrasados</button>
                <button onClick={() => setFiltro('pago')} style={{ marginRight: '10px', padding: '8px 16px', borderRadius: '20px', border: 'none', background: filtro === 'pago' ? '#38a169' : '#e2e8f0', color: filtro === 'pago' ? 'white' : '#4a5568', cursor: 'pointer' }}>Pagos</button>
            </div>

            {/* Lista */}
            <div style={{ background: 'white', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead style={{ background: '#f7fafc', borderBottom: '2px solid #edf2f7' }}>
                        <tr>
                            <th style={{ padding: '15px', textAlign: 'left', color: '#4a5568' }}>Loja</th>
                            <th style={{ padding: '15px', textAlign: 'left', color: '#4a5568' }}>Vencimento</th>
                            <th style={{ padding: '15px', textAlign: 'left', color: '#4a5568' }}>Valor Total</th>
                            <th style={{ padding: '15px', textAlign: 'left', color: '#4a5568' }}>Pago</th>
                            <th style={{ padding: '15px', textAlign: 'left', color: '#4a5568' }}>Status</th>
                            <th style={{ padding: '15px', textAlign: 'left', color: '#4a5568' }}>Loja</th>
                            <th style={{ padding: '15px', textAlign: 'right', color: '#4a5568' }}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listaFiltrada.map(fatura => (
                            <tr key={fatura.fatura_id} style={{ borderBottom: '1px solid #edf2f7' }}>
                                <td style={{ padding: '15px' }}>{fatura.loja_nome}</td>
                                <td style={{ padding: '15px' }}>{new Date(fatura.vencimento).toLocaleDateString()}</td>
                                <td style={{ padding: '15px' }}>R$ {fatura.valor.toFixed(2)}</td>
                                <td style={{ padding: '15px' }}>
                                    <span style={{ color: (fatura.valor_pago || 0) > 0 ? '#38a169' : '#718096', fontWeight: 'bold' }}>
                                        R$ {(fatura.valor_pago || 0).toFixed(2)}
                                    </span>
                                </td>
                                <td style={{ padding: '15px' }}>
                                    <span style={{
                                        padding: '4px 8px',
                                        borderRadius: '12px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: 
                                            fatura.status === 'pago' ? '#c6f6d5' :
                                            fatura.status === 'parcial' ? '#e9d8fd' :
                                            fatura.status === 'atrasado' ? '#fed7d7' : '#bee3f8',
                                        color: 
                                            fatura.status === 'pago' ? '#2f855a' :
                                            fatura.status === 'parcial' ? '#6b46c1' :
                                            fatura.status === 'atrasado' ? '#c53030' : '#2b6cb0'
                                    }}>
                                        {fatura.status.toUpperCase()}
                                    </span>
                                </td>
                                <td style={{ padding: '15px' }}>
                                    <span style={{
                                        padding: '4px 8px',
                                        borderRadius: '12px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: fatura.loja_status === 'bloqueada_financeiro' ? '#fed7d7' : '#c6f6d5',
                                        color: fatura.loja_status === 'bloqueada_financeiro' ? '#c53030' : '#2f855a'
                                    }}>
                                        {fatura.loja_status === 'bloqueada_financeiro' ? 'BLOQ' : 'ATIVA'}
                                    </span>
                                </td>
                                <td style={{ padding: '15px', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                    
                                    <button
                                        onClick={() => setModalHistorico({ aberto: true, fatura: fatura })}
                                        title="Ver Histórico"
                                        style={{
                                            background: '#4a5568', color: 'white', border: 'none',
                                            padding: '6px 10px', borderRadius: '4px', cursor: 'pointer'
                                        }}
                                    >
                                        📋
                                    </button>

                                    {fatura.status !== 'pago' && (
                                        <button 
                                            onClick={() => abrirModalPagamento(fatura)}
                                            style={{
                                                background: '#38a169', color: 'white', border: 'none',
                                                padding: '6px 12px', borderRadius: '4px', cursor: 'pointer'
                                            }}
                                        >
                                            Pagar
                                        </button>
                                    )}
                                    
                                    {fatura.status === 'atrasado' && fatura.loja_status !== 'bloqueada_financeiro' && (
                                        <button 
                                            onClick={() => bloquearLoja(fatura.loja_id, 'bloquear')}
                                            style={{
                                                background: '#e53e3e', color: 'white', border: 'none',
                                                padding: '6px 12px', borderRadius: '4px', cursor: 'pointer'
                                            }}
                                        >
                                            Bloquear
                                        </button>
                                    )}

                                    {fatura.loja_status === 'bloqueada_financeiro' && (
                                        <button 
                                            onClick={() => bloquearLoja(fatura.loja_id, 'desbloquear')}
                                            style={{
                                                background: '#ecc94b', color: 'white', border: 'none',
                                                padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', color: '#744210'
                                            }}
                                        >
                                            Liberar
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Modal de Pagamento */}
            {modalPagamento.aberto && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{ background: 'white', padding: '20px', borderRadius: '8px', minWidth: '400px' }}>
                        <h3 style={{ marginBottom: '15px' }}>Registrar Pagamento</h3>
                        <p style={{ marginBottom: '10px' }}>Loja: <b>{modalPagamento.fatura.loja_nome}</b></p>
                        
                        <div style={{ marginBottom: '10px' }}>
                            <label style={{ display: 'block', marginBottom: '5px' }}>Valor (R$)</label>
                            <input 
                                type="number" 
                                value={modalPagamento.valor} 
                                onChange={e => setModalPagamento({...modalPagamento, valor: e.target.value})}
                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                            />
                        </div>

                        <div style={{ marginBottom: '10px' }}>
                            <label style={{ display: 'block', marginBottom: '5px' }}>Forma de Pagamento</label>
                            <select 
                                value={modalPagamento.forma}
                                onChange={e => setModalPagamento({...modalPagamento, forma: e.target.value})}
                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                            >
                                <option value="Pix">Pix</option>
                                <option value="Boleto">Boleto</option>
                                <option value="Cartão">Cartão</option>
                                <option value="Dinheiro">Dinheiro</option>
                                <option value="Outro">Outro</option>
                            </select>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '5px' }}>Ação na Loja</label>
                            <select 
                                value={modalPagamento.acao}
                                onChange={e => setModalPagamento({...modalPagamento, acao: e.target.value})}
                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                            >
                                <option value="manter">Manter status atual</option>
                                <option value="desbloquear">Desbloquear Loja (Se bloqueada)</option>
                                <option value="bloquear">Bloquear Loja</option>
                            </select>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button 
                                onClick={() => setModalPagamento({...modalPagamento, aberto: false})}
                                style={{ padding: '8px 16px', background: '#e2e8f0', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                            >
                                Cancelar
                            </button>
                            <button 
                                onClick={enviarPagamento}
                                style={{ padding: '8px 16px', background: '#38a169', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                            >
                                Confirmar Pagamento
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Histórico */}
            {modalHistorico.aberto && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{ background: 'white', padding: '20px', borderRadius: '8px', minWidth: '500px', maxHeight: '80vh', overflowY: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                            <h3>Histórico de Pagamentos</h3>
                            <button onClick={() => setModalHistorico({aberto: false, fatura: null})} style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '18px' }}>&times;</button>
                        </div>
                        
                        {modalHistorico.fatura.pagamentos && modalHistorico.fatura.pagamentos.length > 0 ? (
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ background: '#f7fafc', textAlign: 'left' }}>
                                        <th style={{ padding: '8px' }}>Data</th>
                                        <th style={{ padding: '8px' }}>Valor</th>
                                        <th style={{ padding: '8px' }}>Forma</th>
                                        <th style={{ padding: '8px' }}>Usuário</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {modalHistorico.fatura.pagamentos.map((pag, index) => (
                                        <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                                            <td style={{ padding: '8px' }}>{new Date(pag.data).toLocaleDateString()} {new Date(pag.data).toLocaleTimeString()}</td>
                                            <td style={{ padding: '8px', color: '#38a169', fontWeight: 'bold' }}>R$ {pag.valor.toFixed(2)}</td>
                                            <td style={{ padding: '8px' }}>{pag.forma}</td>
                                            <td style={{ padding: '8px', fontSize: '12px', color: '#718096' }}>{pag.usuario || 'Sistema'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p style={{ color: '#718096', textAlign: 'center', padding: '20px' }}>Nenhum pagamento registrado.</p>
                        )}
                    </div>
                </div>
            )}

            </div>
            </main>
        </div>
    );
};

export default FinanceiroAdmin;
